module.exports = __webpack_public_path__ + "static/media/yafa_4.3abdde1e.jpg";